import { ComponentType, lazy, LazyExoticComponent } from "react";
import { ConnectedComponent } from "react-redux";
import retry from "async-retry";
import { logError } from "@src/appV2/lib/analytics";

// in order to mimic what React.lazy does, we use the same function's signature
// https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/types/react/index.d.ts#L881
export function loadLazily<
  // FIXME: Automatically disabled during ESLint config update
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  T extends ComponentType<unknown> | ConnectedComponent<any, any> | React.FC<any>,
>(factory: () => Promise<{ default: T }>): LazyExoticComponent<T> {
  return lazy(async () => {
    try {
      return await retry(factory, {
        retries: 2,
        minTimeout: 200,
      });
    } catch (error) {
      logError("Lazy chunk load failure", {
        error,
        metadata: { url: window.location.href },
      });
      throw error;
    }
  });
}
